/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from native/schemas/camera/Camera.yaml
/** @hidden */
export const CameraLiveScannerResolutionValues = [
    'AUTO',
    'FULL_HD',
    'UHD',
];
//# sourceMappingURL=Camera.js.map